import React, { useEffect, useState } from "react";

import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Grid from "../ui/Grid";
import dayjs from "dayjs";
import { bm_date, getConditionNameFromCode } from "../utils/Utils";
import Nav from "../ui/Nav";

import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { render } from "@testing-library/react";
import Drag from "../hooks/Drag";
import Table from "../ui/Table";


export default function OtherConditions(props) {

    const { controller="", data = [], callback = () => { } } = props;
    const [loading, setLoading] = useState(false);


    const fetchTitle = (_stock) => {

        if(loading) return; 
        setLoading(true)

        pubCall("stock.getSingleExtras", { stock_id: _stock?.stock_id, grid_type: "", want_other_conditions: true, want_pending_orders: false, want_pubstock: false }, (_s, _r) => {
            if(_s){
                callback(_r);
            } else {
                showError(_r);
            }
            setLoading(false)
        })

    }

    
  


    const columns = [
        {
            key: "condition_code", shrink: true, grow: true, align: "left", title: <>Condition</>, render: (e, f) => {
                return (<strong style={{ "fontWeight": "800" }}><a onClick={() => fetchTitle(f)}>{getConditionNameFromCode(e)}</a></strong>)
            }
        },
        {
            key: "code", shrink: true, grow: true, align: "left", title: <>Code</>, render: (e, f) => {
                return (<strong style={{ "fontWeight": "800" }}><a onClick={() => fetchTitle(f)}>{f.condition_code}</a></strong>)
            }
        },
        {
            key: "available_on_hand", grow: true, title: <>O/H</>, render: (e) => {
                return (<span className="text-green">{e}</span>)
            }
        },
        {
            key: "on_order", grow: true, title: <>O/O</>, render: (e) => {
                return (<span className="text-green">{e}</span>)
            }
        },
        { key: "price", grow: true, title: <>Price</> },

    ]

    if(!data?.length){
        return(<></>)
    }
    
    return (
        <>
            <div style={{ "borderBottom": "1px solid var(--border-secondary)", "margin" : "0px 0px", "marginTop" : "0px" }}>
                <Table
                    controller={controller}
                    grow
                    inline
                    height={"auto"}
                    offset={0}
                    columns={columns}
                    width={"auto"}
                    data={data}
                    row_key={"stock_id"}
                />
            </div>
        </>
    )
}